'use client';

import type { AuctionStatusFilter } from './types';

export const AUCTION_STATUS_FILTERS: readonly AuctionStatusFilter[] = [
  'all',
  'ACTIVE',
  'PENDING',
  'COMPLETED',
] as const;

export const AUCTION_TIMER_INTERVAL = 1000;
